import { Stack } from '@mui/material';

import { Typography } from '@occc/ui-design-system';
import { OfferFilter } from '@occc/graphql';

import { OfferSelect } from '../../../CampaignComponents/components/OfferSelect';

type PurchasableOfferSelectorProps = {
  makeOffersFilter: () => OfferFilter;
};
export const PurchasableOfferSelector = (props: PurchasableOfferSelectorProps) => {
  const { makeOffersFilter } = props;
  return (
    <Stack>
      <Typography gutterBottom fontWeight='bold'>
        Allow members to purchase additional gameplays
      </Typography>
      <OfferSelect
        makeOffersFilter={makeOffersFilter}
        label='Purchasable Offer'
        name='purchasableOffer'
      />
    </Stack>
  );
};
